import { z } from 'zod';

/**
 * The liveness-probe payload. Deliberately free of any brand, deployment, or
 * version detail — this endpoint is reachable unauthenticated by the load
 * balancer and the container healthcheck, so it must leak nothing.
 */
export const HealthStatusSchema = z.object({
  status: z.literal('ok'),
  uptimeSeconds: z.number().int().min(0),
});

export type HealthStatus = z.infer<typeof HealthStatusSchema>;

export const ReadinessCheckSchema = z.enum(['ok', 'fail']);

export type ReadinessCheck = z.infer<typeof ReadinessCheckSchema>;

/**
 * The readiness-probe payload: one verdict per dependency the api cannot serve
 * without. The endpoint answers 503 when `status` is `degraded`, so a rollout
 * gate needs only the status code; the body is for the operator.
 */
export const ReadinessStatusSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  checks: z.object({
    postgres: ReadinessCheckSchema,
    redis: ReadinessCheckSchema,
  }),
});

export type ReadinessStatus = z.infer<typeof ReadinessStatusSchema>;
